<template>
    <div class="customer-revenue">
        <div class="row">
            <div class="col-lg-6">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="customers.customerRevenue" />
                        Hvilke konkrete kunder tjener vi penge på?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectCustomer"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | rounded }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="info" v-if="!selectedRow">
                    Vælg en kunde for at se en liste over alle kundens opgaver
                </div>
                <customer-revenue-single :data="selectedRow" v-else />
            </div>
        </div>
    </div>
</template>

<script>
import * as customerService from '@/services/customerService'

export default {
    data () {
        return {
            selectedRow: null,
            loading: false,
            rows: [],
            columns: [
                { label: 'Kunde', field: 'name', type: 'string' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        (async () => {
            await this.getData()
            // this.$store.commit('setCustomerRevenueRows', this.rows)
        })()
    },
    methods: {
        getData () {
            return new Promise((resolve, reject) => {
                this.loading = true
                this.$emit('finishedLoading', null)
                this.$store.commit('setCustomerRevenueRows', [])
                this.selectedRow = null
                let params = {
                    date_from: this.$store.getters.getStartDate,
                    date_to: this.$store.getters.getEndDate
                }
                if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                    params.department = this.$store.getters.getCurrentDepartment.uuid
                }
                customerService.customerActivity(params, (response) => {
                    this.rows = response.data
                    this.$emit('finishedLoading', this.rows.length)
                    this.loading = false
                    this.$store.commit('setCustomerRevenueRows', this.rows)
                    resolve(response.data)
                }, (err) => {
                    console.log(err)
                    this.loading = false
                    reject(err)
                })
            })
        },
        selectCustomer (customer) {
            this.selectedRow = customer.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected'
            }
        }
    },
    components: {
        'customer-revenue-single': require('./customerRevenueSingle.vue')
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// customerRevenue.vue?42544746